import promotionalCodesApi from 'api/requests/promotionalCodes';
import Button from 'components/_UI/Button';
import Loader from 'components/_UI/Loader';
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import React, { useState } from 'react'
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import buttonText from 'texts/buttons/buttonText';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

export default function DeleteDiscountCodeModal({ data, visible, toast, onClose, onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    async function deleteCode() {
        setLoading(true);
        setError(false);

        try {
            await promotionalCodesApi.delete(data?.id);
            onSuccess();
            toast.success('Código promocional excluido com sucesso!', {
                position: 'top-center'
            })
        } catch (error) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal isOpen={visible} onClose={onClose} >
            <Text name='highlight'>
                Excluir código
            </Text>

            <Text name='normal' marginTop='10px'>
                Tem certeza que quer excluir o código <b>{data?.code}</b>?
            </Text>

            {
                loading ? (
                    <FullyCentered height='40px'>
                        <Loader />
                    </FullyCentered>
                ) : (
                    <ButtonsContainer>
                        <Button
                            variant={'light'}
                            category={'roundedBorded'}
                            onClick={onClose}
                        >
                            {buttonText.cancel}
                        </Button>

                        <Button
                            category={'roundedBorded'}
                            variant='lightBlue'
                            onClick={deleteCode}
                        >
                            {buttonText.delete}
                        </Button>
                    </ButtonsContainer>
                )
            }

            {error && (
                <Text color={colors.danger} name='small'>
                    Ocorreu um erro inesperado, tente novamente!
                </Text>
            )}
        </Modal>
    )
}

const ButtonsContainer = styled(Column)`
    margin-top: 20px;

    @media screen and (min-width: ${breakpoints.md}) {
    flex-direction: row;
    
    button:nth-child(2) {
        margin-left: 10px;
    }
}
`;
